import React, {useEffect} from 'react';
import FuseShortcuts from '@fuse/core/FuseShortcuts';
import AppBar from '@material-ui/core/AppBar';
import Hidden from '@material-ui/core/Hidden';
import { makeStyles, ThemeProvider } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
//import ChatPanelToggleButton from 'app/fuse-layouts/shared-components/chatPanel/ChatPanelToggleButton';
import NavbarMobileToggleButton from 'app/fuse-layouts/shared-components/NavbarMobileToggleButton';
//import QuickPanelToggleButton from 'app/fuse-layouts/shared-components/quickPanel/QuickPanelToggleButton';
import UserMenu from 'app/fuse-layouts/shared-components/UserMenu';
//import Menu from 'app/fuse-layouts/shared-components/Menu';

import LanguageSwitcher from '../../shared-components/LanguageSwitcher';
import FullScreenToggle from '../../shared-components/FullScreenToggle';
import { useLocation } from 'react-router-dom';
import { useDeepCompareEffect } from '@fuse/hooks';
import { useDispatch, useSelector } from 'react-redux';
import * as Actions from 'app/store/actions';
import useBreakpoint from 'use-breakpoint';

const useStyles = makeStyles(theme => ({
	separator: {
		width: 1,
		height: 50,
		backgroundColor: theme.palette.divider
	}
}));

const BREAKPOINTS = { mobile: 0, tablet: 768, desktop: 1280 }


function ToolbarLayout1(props) {
	const dispatch = useDispatch();
	const config = useSelector(({ fuse }) => fuse.settings.current.layout.config);
	const toolbarTheme = useSelector(({ fuse }) => fuse.settings.toolbarTheme);
	const location = useLocation();
	const classes = useStyles(props);
	const { pathname } = location;
	const { breakpoint/*, maxWidth, minWidth*/ } = useBreakpoint(BREAKPOINTS, 'desktop');
	const getSideMenuItems = useSelector(({ multipleCompanies }) => multipleCompanies.multipleCompanies.getSideMenuItems);


	useEffect(()=>{
		dispatch(Actions.getSideMenuItems());
		// eslint-disable-next-line react-hooks/exhaustive-deps
	},[]);


	/*useEffect(()=>{
		console.log('GET SIDE MENU DATA ======= ', getSideMenuItems)
	},[getSideMenuItems])*/


	useDeepCompareEffect(() => {
		dispatch(Actions.members_getProjectBranch(JSON.parse(localStorage.getItem('persistCompanyID'))));
		dispatch(Actions.members_getProjects(JSON.parse(localStorage.getItem('persistCompanyID'))));
		//console.log('pathname', pathname)
	}, [dispatch]);


	return (
		<ThemeProvider theme={toolbarTheme}>
			<AppBar
				id="fuse-toolbar"
				className="flex relative z-10"
				color="default"
				style={{ 
					backgroundColor: toolbarTheme.palette.background.default, 
					position: breakpoint !== "desktop" && 'fixed',
					top: breakpoint !== "desktop" && 0,
					zIndex: breakpoint !== "desktop" && 9999,
					height: "50px",
				}}
			>
				<Toolbar className="p-0" style={{minHeight:"50px"}}>
					{config.navbar.display && config.navbar.position === 'left' && (
						<Hidden lgUp>
							<NavbarMobileToggleButton className="w-64 h-50 p-0" />
							<div className={classes.separator} />
						</Hidden>
					)}

					<div className="flex flex-1">
						{getSideMenuItems.length !== 0 ?  <FuseShortcuts className="" /> : null}
					</div>

					<div className="flex items-center px-8">
						<UserMenu />
						<Hidden mdDown>
							<LanguageSwitcher />

							<FullScreenToggle />
						</Hidden>
						{/* <Hidden lgUp>
							{(!pathname.startsWith('/chat') && !pathname.startsWith('/ctm')) && <ChatPanelToggleButton />}
						</Hidden> */}

						{/* <Menu /> */}
					</div>

					{config.navbar.display && config.navbar.position === 'right' && (
						<Hidden lgUp>
							<NavbarMobileToggleButton />
						</Hidden>
					)}
				</Toolbar>
			</AppBar>
		</ThemeProvider>
	);
}

export default React.memo(ToolbarLayout1);
